import PropTypes from "prop-types";
import Avatar from "@/components/common/Avatar";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";
import { Link } from "react-router-dom";
import { Dropdown } from "antd";

const PollsAndSurveyCard = ({
  _id,
  title,
  description,
  author,
  avatar,
  onDelete,
  onModify,
}) => {
  const handleMenuClick = (menuItem, e) => {
    e?.domEvent?.stopPropagation();
    if (menuItem.key === "delete") {
      onDelete(_id, title);
    } else if (menuItem.key === "modify") {
      onModify(_id);
    }
  };

  return (
    <div className="rounded-lg text-left p-4 bg-[var(--header-bg)] w-full">
      <div className="flex justify-between items-start w-full">
        <Link to={`/dashboard/polls/${_id}`} className="flex-1 min-w-0">
          <div className="flex flex-col gap-1">
            <h3 className="text-bold-x text-darkGrey truncate" title={title}>
              {title}
            </h3>
            <p
              className="text-regular text-lighterGrey truncate"
              title={description}>
              {description}
            </p>
            <div className="flex items-center gap-2">
              <Avatar
                size={32}
                src={avatar}
                className="border-2 border-gray-100"
              />
              <span className="text-regular text-lighterGrey">{author}</span>
            </div>
          </div>
        </Link>

        <Dropdown
          menu={{
            items: [
              {
                key: "modify",
                label: "Modify",
                onClick: (e) => handleMenuClick({ key: "modify" }, e),
              },
              {
                key: "delete",
                label: "Delete",
                onClick: (e) => handleMenuClick({ key: "delete" }, e),
              },
            ],
          }}
          trigger={["click"]}
          onClick={(e) => e.stopPropagation()}>
          <button
            className="p-2 rounded-full ml-4"
            onClick={(e) => e.stopPropagation()}>
            <CustomMoreOptions variant="filled" orientation="vertical" />
          </button>
        </Dropdown>
      </div>
    </div>
  );
};

PollsAndSurveyCard.propTypes = {
  _id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  author: PropTypes.string,
  avatar: PropTypes.string,
  onDelete: PropTypes.func,
  onModify: PropTypes.func,
};

export default PollsAndSurveyCard;
